import PropTypes from 'prop-types';
import React from 'react';
import { Input, InputBox, Label, ActiveBar } from './InputStyles';

const DefaultInput = props => {
  const { label, input, meta, type, disabled } = props;
  const { invalid, submitFailed } = meta;
  const showError = invalid && submitFailed;

  return (
    <InputBox disabled={disabled}>
      <Label active={meta.active || input.value !== ''} error={showError}>
        {label}
      </Label>
      <ActiveBar active={meta.active} error={showError} />
      <Input type={type} {...input} {...props} />
    </InputBox>
  );
};

DefaultInput.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  inputLabelProps: PropTypes.object
};

export default DefaultInput;



// WEBPACK FOOTER //
// ./src/components/Inputs/DefaultInput.js